import { padStart } from 'lodash';

export function percentFormat(percent: number) {
  const formattedValue = percent.toFixed(2);
  const [integerPart, decimalPart] = formattedValue.split('.');

  let decimalFormatted = '';
  if (decimalPart === '00' || decimalFormatted.length === 2) {
    decimalFormatted = `${decimalPart}%`;
  } else if (decimalPart.length === 1) {
    decimalFormatted = `${decimalPart}0%`;
  }

  return `${integerPart}.${decimalFormatted}`;
}

export function convertDurationInSecondIntoDisplayTimeFormat(duration: number, type: 'full' | 'simple'): string {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  let text = '';

  if (hours > 0) {
    const formattedHours = padStart(hours.toString(), 2, '0');
    const displayHours = type === 'full' ? `${formattedHours} giờ ` : `${formattedHours}h `;
    text += displayHours;
  }

  if (minutes > 0) {
    const formattedMinutes = padStart(minutes.toString(), 2, '0');
    const displayMinutes = type === 'full' ? `${formattedMinutes} phút ` : `${formattedMinutes}m `;
    text += displayMinutes;
  }

  if (seconds > 0) {
    const formattedSeconds = padStart(seconds.toString(), 2, '0');
    const displaySeconds = type === 'full' ? `${formattedSeconds} giây` : `${formattedSeconds}s`;
    text += displaySeconds;
  }

  return text.trim();
}

export function formatDurationIntoXmXXSeconds(seconds: number) {
  const roundedSeconds = Math.floor(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;

  return `${minutes}m${remainingSeconds}s`;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/campaign/util.ts